<template>
  <div style="width: 100%">
    <el-tabs v-model="activeName">
      <el-tab-pane disabled name="first">
        <el-breadcrumb
          slot="label"
          style="margin-top: 13px"
          separator-class="el-icon-arrow-right"
        >
          <el-breadcrumb-item :to="{ path: '/myscore' }"
            >我的成绩</el-breadcrumb-item
          >
          <el-breadcrumb-item>成绩查询</el-breadcrumb-item>
        </el-breadcrumb>
      </el-tab-pane>
    </el-tabs>

    <div class="boxCell" v-for="(item, index) in list" :key="index">
      <a :href="item.url" target="_blank">
        <div style="display: flex; align-items: center; color: #333">
          <img
            style="width: 50px; height: 50px"
            src="@/assets/image/slogo.png"
            alt=""
          />
          <div style="padding: 5px 20px; flex: 1">
            <h2>{{ item.name }}</h2>
            <p style="margin-top: 10px">考试时间：{{ examTime }}</p>
          </div>

          <el-button type="primary"> 查看成绩 </el-button>
        </div>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeName: "first",
      examTime: "",
      list: [],
      list1: [
        {
          name: "底盘检验员、引车员、辅助员",
          url: "https://www.wjx.cn/resultquery.aspx?activity=93690438",
        },
        {
          name: "设备维护员、网管员、登录员",
          url: "https://www.wjx.cn/resultquery.aspx?activity=93680806",
        },
        {
          name: "技术负责人、质量负责人、授权签字人、内审员",
          url: "https://www.wjx.cn/resultquery.aspx?activity=93681335",
        },
      ],
      list2: [
        { name: "安综环引车、辅助",  url: "https://www.wjx.cn/resultquery.aspx?activity=99109916",  },
        {  name: "设备、登录、网管",  url: "https://www.wjx.cn/resultquery.aspx?activity=99110588",  },
        { name: "外检员",  url: "https://www.wjx.cn/resultquery.aspx?activity=99109155",  },
        {  name: "底盘检验员",  url: "https://www.wjx.cn/resultquery.aspx?activity=99108885",  },
        { name: "管理岗",  url: "https://www.wjx.cn/resultquery.aspx?activity=97899600",   },
      ],
      list3:[
       
         { name: "质量负责人",  url: "https://www.wjx.cn/resultquery.aspx?activity=103530757" },
         { name: "内审员",  url: "https://www.wjx.cn/resultquery.aspx?activity=103530642" },
         { name: "技术负责人",  url: "https://www.wjx.cn/resultquery.aspx?activity=103532434" },
         { name: "授权签字人",  url: "https://www.wjx.cn/resultquery.aspx?activity=103532112" },
         { name: "安综引车员",  url: "https://www.wjx.cn/resultquery.aspx?activity=103531827" },
         { name: "底盘检验员",  url: "https://www.wjx.cn/resultquery.aspx?activity=103531774" },
         { name: "登录员",  url: "https://www.wjx.cn/resultquery.aspx?activity=103533475" },
         { name: "网管员",  url: "https://www.wjx.cn/resultquery.aspx?activity=103532669" },
         { name: "设备维护员",  url: "https://www.wjx.cn/resultquery.aspx?activity=103534106" },
         { name: "外检员",  url: "https://www.wjx.cn/resultquery.aspx?activity=103533597" },
         { name: "环检引车员",  url: "https://www.wjx.cn/resultquery.aspx?activity=103533764" },
         { name: "环检辅助员",  url: "https://www.wjx.cn/resultquery.aspx?activity=103535139" }, 
      ]
    };
  },
  activated() {
    let month = this.$route.query.month;
    if (month == 9) {
      this.list = this.list1;
      this.examTime = "2020-09-27";
    }else if(month==11) {
      this.list = this.list2;
      this.examTime = "2020-11-15";
    } else if(month==12) {
      this.list = this.list3;
      this.examTime = "2020-12-27";
    } else {
      this.list = this.list2;
      this.examTime = "2020-11-15";
    }


    
  },
};
</script>

<style lang="less" scoped>
.boxCell {
  margin: 10px auto 20px;

  border: 1px solid #e6e6e6;
  padding: 10px 20px;
  width: 700px;
}
</style>